import { useContext, useState } from "react";
import styled from "styled-components";
import { PageContext } from "../../../Context/PageContext";
import NameIcon from "./meucadastro/img/account_circle.png"
import EmailIcon from "./meucadastro/img/mail.png"
import KeyIcon from "./meucadastro/img/key.png"
import HistoricIcon from "./meucadastro/img/historic.png"
import StarIcon from "./meucadastro/img/goldstar.png"
import ColorEmailIcon from "./meucadastro/img/emailcolor.png"
import TicketIcon from "./meucadastro/img/ticket.png"
import HistoricLog from "./meucadastro/HistoricLog";
import VipRequestLog from "./meucadastro/VipRequestLog";
import MessageListLog from "./meucadastro/MessageListLog";
import PopMenuWindow, { OpenPopMenu } from "../../../PopMenuWindow/PopMenuWindow";
import ChangeLionsUserPassword from "./meucadastro/ChangeLionsUserPassword";
import TicketPanel from "./meucadastro/TicketPanel";
import CreateNewTicket from "./meucadastro/CreateNewTicket";
import EditImg from "./img/border_color_black.png"
import MeuCadastroIcon from "../img/my_register.gif"


function MeuCadastro() {

    const { user, setPopMenuContent, } = useContext(PageContext);

    const [logItem, setLogItem] = useState(<HistoricLog/>)

    return(
        <MasterContainer>

            <TitleMaster>
                <ColumItemHeaderIcon iconImg={MeuCadastroIcon}/>
                <TitleFont>Dados cadastrais </TitleFont>
            </TitleMaster>

            <MiddleContainer>

                <ProfileContainer>

                    <TitleContainer>
                        <SpanTitle>Meu Perfil</SpanTitle>
                    </TitleContainer>

                    <InfoItemContainer>
                        <ColumItemHeader>
                            <ColumItemHeaderName>Username</ColumItemHeaderName>
                        </ColumItemHeader>
                        <Input>{user.userName}</Input>
                        <EditDisabled  />

                    </InfoItemContainer>

                    <InfoItemContainer>
                        <ColumItemHeader>
                            <ColumItemHeaderName>Password</ColumItemHeaderName>
                        </ColumItemHeader>
                        <Input>*******</Input>
                        <Edit 
                        onClick={() => {
                            OpenPopMenu();
                            setPopMenuContent(<ChangeLionsUserPassword/>)}}
                        />
                    </InfoItemContainer>
                    
                    <InfoItemContainer>
                        <ColumItemHeader>
                            <ColumItemHeaderName>Email</ColumItemHeaderName>
                        </ColumItemHeader>
                        <Input>*******</Input>
                        <EditDisabled  />
                    </InfoItemContainer>

                    <InfoItemContainer>
                        <ColumItemHeader>
                            <ColumItemHeaderName>Aniversário</ColumItemHeaderName>
                        </ColumItemHeader>
                        <Input>01/10/2021</Input>
                        <EditDisabled  />
                    </InfoItemContainer>

                    <InfoItemContainer>
                        <ColumItemHeader>
                            <ColumItemHeaderName>PIN</ColumItemHeaderName>
                        </ColumItemHeader>
                        <Input>*****</Input>
                        <EditDisabled  />
                    </InfoItemContainer>

                    <InfoItemContainer>
                        <ColumItemHeader>
                            <ColumItemHeaderName>Criar Ticket</ColumItemHeaderName>
                        </ColumItemHeader>
                        <Input>CLICAR</Input>
                        <Edit
                            onClick={() => {
                                OpenPopMenu();
                                setPopMenuContent(<CreateNewTicket/>)}}
                        />
                    </InfoItemContainer>

                </ProfileContainer>
            </MiddleContainer>

        </MasterContainer>
    );
}

export default MeuCadastro;

const MasterContainer = styled.div`
    display: flex;
    flex-direction: column;
    //border: solid;
    width: 100%;
    align-items: center;
    margin: 30px 0 200px 0;

    @media(max-width: 1000px) {
      width: 90vw;
    }
`

const TitleMaster = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    border-radius: 10px;
    transition: .3s ease-in-out;
    margin: 30px 0;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 0 0px;
    }

`

const TitleFont = styled.span`
    font-size: 24pt;
    font-weight: bold;
    margin: 25px 0;

    @media(max-width: 1000px) {
      font-size: 20pt
    }

`


const Span = styled.span`
    font-size: 18px;
    font-weight: normal;
    //border: solid 2px black;
    padding: 0;
    text-align: center;
    margin: 10px;
`;

const Title = styled.h3`
    text-align: center;
    //border: solid 2px black;
    padding: 0;
    margin: 0px 0;
`;

const MiddleContainer = styled.div`
    display: flex;
    align-items: start;
    flex-direction: column;
    width: 100%;
    justify-content: space-evenly;
    margin-bottom: 100px;
    transition: .3s ease-in-out;
    //border: solid;

    @media(max-width: 1000px) {
        width: 95vw;
        flex-direction: column;
        margin-bottom: 0px;
        scale: .9;
    }

`

const ProfileContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 0px;
    border-radius: 10px;
    width: 100%;
    //box-shadow: 0 0 10px 0 black;
    transition: .3s ease-in-out;
    color: white;
    background-color: rgba(0, 0, 0, 0.7);

    &:hover{
        //scale: 1.05;
    }

    @media(max-width: 1000px) {
        width: 100%;
    }

`

const TitleContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: start;
    //border: solid;
    //margin: 0 0 0 30px;
`

const SpanTitle = styled.span`
    font-size: 24pt;
    margin-left: 30px;
    margin-bottom: 30px;
    font-weight: bold;


`

const InfoItemContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    //background-color: rgba(0,0,0,.5);
    //border: solid 2px black;
    margin: 5px 0;

`
const ColumItemHeader = styled.div`
    display: flex;
    align-items: center;
    width: 130px;
    font-size: 14pt;
    //border: solid 2px black;
    margin-left: 30px;
`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 45px;
    height: 45px;
    margin: 0 55px;

     @media(max-width: 1000px) {
        width: 35px;
        height: 35px;
        margin: 0 20px;
    }
`

const ColumItemHeaderName = styled.span`
    display: flex;
    align-items: center;
    //border: solid;

    @media (max-width: 1000px) {
        width: 110px;
    }
`

const Input = styled.span`
    display: flex;
    align-items: center;
    border-radius: 0px;
    font-weight: bold;
    background-color: rgba(0,0,0,.2);
    padding: 10px 20px;
    border-radius: 5px;
    font-size: 12pt;
    color: white;
    width: 300px;

    @media (max-width: 1000px) {
        width: 110px;
        border-bottom: solid 1px rgba(0,0,0,0);
    }

`

const Edit = styled.div`
    background-image: url(${EditImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 5px;
    border: 2px solid black;
    background-color: rgba(255, 255, 255, 0.9);
    //padding: 5px;
    padding: 15px;
    margin-left: 30px;
    z-index: 3;
    transition: .3s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
        scale: 1.2;
    }

    @media (max-width: 1000px) {
        margin-left: 10px;
    }

`

const EditDisabled = styled.div`
    background-image: url(${EditImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 5px;
    border: 1px solid;
    background-color: rgba(255, 255, 255, 0.9);
    //padding: 5px;
    padding: 15px;
    margin-left: 30px;
    z-index: 3;
    pointer-events: none;
    opacity: .3;
    scale: .8;
    transition: .3s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    scale: 1.2;
    }

    @media (max-width: 1000px) {
        margin-left: 10px;
    }

`

const OptionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    @media(max-width: 1000px) {
    margin-top: 50px;
    }
`


const OptionsItemHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 230px;
    padding: 30px 20px;
    border-radius: 10px;
    margin-bottom: 50px;
    //border: solid 1px black;
    color: white;
    background-color: rgb(32, 106, 151);
    opacity: .8;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    transition: .3s ease-in-out;

    &:hover{
    scale: 1.05;
    opacity: 1;
    }
`


const LogsHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    padding: 10px;
    border-bottom: solid 1px rgba(0,0,0,.3);

     @media(max-width: 1000px) {
        width: 100%;
        flex-direction: column;
        border-bottom: solid 1px rgba(0,0,0,.0);
    }

`

const LogsHeaderItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14pt;
    margin-right: 10px;
    transition: .3s ease-in-out;
    padding: 20px 40px;
    border-radius: 10px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    scale: 1.1;
    background-color: rgb(32, 106, 151);
    color: white;
    }

     @media(max-width: 1000px) {
        width: 80%;
        margin-right: 0px;
        margin-bottom: 5px;

        &:hover {
            scale: 1.0;
        }
    }

`


